/**
 * DONiTSH!T Brand Asset Registry
 * ------------------------------------------------------------------
 * Centralized constants for all official brand imagery so that the
 * site, emails, and future surfaces (PWA / OG / social previews)
 * point to a single source of truth.
 *
 * Assets live at /public/brand/* (so they are served statically).
 */

export const BRAND = {
  // The official text/emblem logo (gold on black). Use for header, footer,
  // auth pages, and emails. Always wraps a clickable link to "/".
  LOGO: "/brand/logo.jpg",

  // Hero artwork for the homepage and "Be Your Own Coach" section.
  // Meditation + DNA + cosmic motif — represents transformation.
  HERO: "/brand/hero.jpg",

  // Donny mascot avatar — radiant tree-of-life figure, gold/cosmic.
  // Used by the floating concierge bubble and the Ask Donny drawer/page.
  DONNY_AVATAR: "/brand/donny.jpg",

  // Secondary cosmic art (curled tree/root figure). Reserved for
  // editorial accents (e.g. Ask Donny page hero / ambient decor).
  DONNY_COSMIC: "/brand/donny-cosmic.png",
};

export default BRAND;
